import * as Config from "config";

export type JsonPatchOperation = {
  op: string;
  path: string;
  value: unknown;
};

export default class AttorneyHubAPIService {
  static readonly config = {
    headers: {
      'Content-Type': 'application/json'
    } as { [key: string]: string },
  };
  // ----------------------------------------------------------------------------
  // Getters
  // ----------------------------------------------------------------------------

  /** @returns {string} Returns the base URL to use for API calls */
  static get apiBaseUrl(): string {
    return Config.apiBaseUrl;
  }

  // ----------------------------------------------------------------------------
  // Methods
  // ----------------------------------------------------------------------------

  /**
   * Sets the Authorization header for API calls with the given token
   * @param {string} authToken The token to use for the Authorization header
   */
  static setAuthHeader(authToken: string | null |undefined) {
    if (authToken) {
      AttorneyHubAPIService.addHeader("Authorization", `Bearer ${authToken}`);
    } else {
      AttorneyHubAPIService.removeHeader("Authorization");
    }
  }

  /**
   * Adds a header to the headers object
   * @param   {string} name   The name of the header to add
   * @param   {string} value  The value for the header
   * @returns {void}
   */
  static addHeader(name: string, value: string): void {
    AttorneyHubAPIService.config.headers[name] = value;
  }

  /**
   * Adds a header to the headers object
   * @param   {string} name   The name of the header to add
   * @returns {void}
   */
  static removeHeader(name: string): void {
    delete AttorneyHubAPIService.config.headers[name];
  }
}
